module.exports = __webpack_public_path__ + "static/img/dot icon.1d8a9ab5.svg";